import {
  myRoomsResponseSchema,
  roomResponseSchema,
  type MyRoomsResponse,
  type RoomResponse,
} from '../../shared/api';
import type { GameConfig } from '../../shared/config';
import type { GameMode } from '../../shared/modes';
import { API_PATHS, roomApiPath, roomCancelApiPath } from '../../shared/routes';
import { fetchJson } from './http';

export function readRoom(code: string): Promise<RoomResponse> {
  return fetchJson(roomResponseSchema, roomApiPath(code));
}

/** Turn-taking rooms the profile belongs to; 401 means the credential is no longer valid. */
export function readMyRooms(credential: string, signal?: AbortSignal): Promise<MyRoomsResponse> {
  return fetchJson(myRoomsResponseSchema, API_PATHS.myRooms, {
    credential,
    ...(signal ? { signal } : {}),
    failure: 'Your rooms are unavailable.',
  });
}

export interface CreateRoomInput {
  mode: GameMode;
  config: GameConfig;
  cancelToken?: string;
  /** Required for Daily so the server can resolve an existing attempt. */
  credential?: string | null;
}

export function createRoom({
  mode,
  config,
  cancelToken,
  credential,
}: CreateRoomInput): Promise<RoomResponse> {
  return fetchJson(roomResponseSchema, API_PATHS.rooms, {
    method: 'POST',
    json: { mode, config, ...(cancelToken ? { cancelToken } : {}) },
    credential: credential ?? null,
  });
}

export interface PreparedRoomCancellation {
  readonly code: string;
  readonly token: string;
}

/** Keepalive is best effort; durable setup expiry and maintenance remain the retry path. */
export function cancelRoom(room: PreparedRoomCancellation): void {
  void fetch(roomCancelApiPath(room.code), {
    method: 'POST',
    headers: { Authorization: `Bearer ${room.token}` },
    keepalive: true,
  }).catch(() => {});
}
